import { render, staticRenderFns } from "./DeleteRendererNew.vue?vue&type=template&id=7aa61412"
import script from "./DeleteRendererNew.vue?vue&type=script&lang=js"
export * from "./DeleteRendererNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports